import React from 'react';
import { Row, Col, Button, Label } from 'reactstrap';
import { pluck } from 'underscore';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import SinglePicker from '../common/controls/singlePicker';
import AssetAssociationsAreas from './assetAssociationsAreas';
import Icon from '../common/containers/icon';
import { changeItemWithConfirm, removeItemWithConfirm } from '../common/classes/handleItemWithConfirm';
const AssetAssociationsGroups = ({
  areaList,
  onChange,
  groups,
  grpList
}) => {
  const handleAddDefaultArea = index => {
    const areas = JSON.parse(JSON.stringify(groups[index].areas));
    const newArea = {
      id: null
    };
    areas.push(newArea);
    onChange(`groups[${index}]/areas`, areas);
  };
  const handleChangeArea = (index, name, value) => {
    onChange(`groups[${index}]/${name}`, value);
  };
  const handleChangeGroup = (index, value) => {
    const updatedGroup = {
      id: value,
      areas: []
    };
    onChange(`groups[${index}]`, updatedGroup);
  };
  const confirmOnChangeFields = ['areas'];
  const handleChange = (index, value) => changeItemWithConfirm(groups[index], 'Group (All associated areas for this groups will be removed)', confirmOnChangeFields, handleChangeGroup.bind(null, index, value));
  const handleRemoveGroup = index => {
    const newGroups = JSON.parse(JSON.stringify(groups));
    newGroups.splice(index, 1);
    onChange('groups', newGroups);
  };
  const confirmOnRemoveFields = ['id'];
  const handleRemove = index => removeItemWithConfirm(groups[index], 'Group (and nested Areas)', confirmOnRemoveFields, handleRemoveGroup.bind(null, index));
  const usedGroups = pluck(groups, 'id');
  return /*#__PURE__*/React.createElement("div", null, groups.map((group, index) => {
    const groupList = grpList.filter(g => g.id === group.id || !usedGroups.includes(g.id));
    return /*#__PURE__*/React.createElement("div", {
      key: group.id || uuidV4(),
      className: `t-aaf-${index}`
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 7,
        offset: 2
      }
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Associated Group",
      onChange: value => handleChange(index, value),
      options: groupList,
      placeholder: "Select...",
      value: group.id,
      returnValueKey: "id"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      index: index,
      name: "removeGroup",
      size: "sm",
      onClick: () => handleRemove(index),
      className: "float-md-right form-control t-aag-remove-group tqc-control"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "trash"
    }), " Remove Group"))), /*#__PURE__*/React.createElement(AssetAssociationsAreas, {
      areas: group.areas,
      areaList: areaList.filter(area => area.facilityGroupID === group.id),
      onChange: (name, value) => handleChangeArea(index, name, value)
    }), /*#__PURE__*/React.createElement(Row, {
      style: {
        marginBottom: '15px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      index: index,
      size: "sm",
      onClick: () => handleAddDefaultArea(index),
      className: "float-md-right form-control t-aag-add-area tqc-control",
      disabled: group.id === null
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Area"))));
  }));
};
AssetAssociationsGroups.propTypes = {
  areaList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape({
    areas: PropTypes.arrayOf(PropTypes.shape({}))
  })).isRequired,
  grpList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired
};
export default AssetAssociationsGroups;